import { render, staticRenderFns } from "./InstructionRecordsDialog.vue?vue&type=template&id=46003ce0&"
import script from "./InstructionRecordsDialog.vue?vue&type=script&lang=js&"
export * from "./InstructionRecordsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46003ce0')) {
      api.createRecord('46003ce0', component.options)
    } else {
      api.reload('46003ce0', component.options)
    }
    module.hot.accept("./InstructionRecordsDialog.vue?vue&type=template&id=46003ce0&", function () {
      api.rerender('46003ce0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/admin/components/InstructionRecordsDialog.vue"
export default component.exports